import { BASE_SIZE } from '../constant';

const { XL, LG, MD, SM } = BASE_SIZE;

export const BASE_INPUT_SIZE = { XL, LG, MD, SM } as const;

export enum BASE_INPUT_STATUS {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  ERROR = 'error',
}
